// 学校路由

export default [
	/**
	 *** 课程管理
	 **/
	{
		name: "全部课程",
		path: "/courseManager/allCourse",
		component: () => import("@/views/school/courseManager/allCourse/index.vue"),
	},
	{
		name: "学校课程库",
		path: "/courseManager/selfAddCourse",
		component: () => import("@/views/school/courseManager/selfAddCourse/index.vue"),
	},
	{
		name: "机构课程库",
		path: "/courseManager/importCourse",
		component: () => import("@/views/school/courseManager/importCourse/index.vue"),
	},
	{
		name: "系统课程库",
		path: "/courseManager/systemCourse",
		component: () => import("@/views/school/courseManager/systemCourse/index.vue"),
	},
	// {
	// 	name: "材料管理",
	// 	path: "/courseManager/materialManger",
	// 	component: () => import("@/views/school/courseManager/materialManger/index.vue"),
	// },
	{
		name: "巡课管理",
		path: "/courseManager/tourCourse",
		component: () => import("@/views/school/courseManager/tourCourse/index.vue"),
	},

	/**
	 *** 校本选课
	 **/
	{
		name: "选课活动",
		path: "/CourseSelection/activity",
		component: () => import("@/views/school/CourseSelection/activity/index.vue"),
	},
	{
		name: "选课类型",
		path: "/CourseSelection/type",
		component: () => import("@/views/school/CourseSelection/type/index.vue"),
	},

	/**
	 *** 延时课表
	 **/
	{
		name: "延时课表",
		path: "/Schedule",
		component: () => import("@/views/school/Schedule/index.vue"),
	},

	/**
	 *** 作业管理
	 **/
	{
		name: "作业登记",
		path: "/task/register",
		component: () => import("@/views/school/task/register/index.vue"),
		redirect: "/task/register/list",
		children: [
			{
				name: "作业登记",
				path: "/task/register/list",
				component: () => import("@/views/school/task/register/list.vue"),
			},
			{
				name: "开始作业登记",
				path: "/task/register/add",
				component: () => import("@/views/school/task/register/add.vue"),
			},
			{
				name: "查看登记作业",
				path: "/task/register/registerDetail",
				component: () => import("@/views/school/task/register/registerDetail.vue"),
			},
		],
	},
	{
		name: "作业调控",
		path: "/task/regulation",
		component: () => import("@/views/school/task/regulation/index.vue"),
		redirect: "/task/regulation/list",
		children: [
			{
				name: "作业调控",
				path: "/task/regulation/list",
				component: () => import("@/views/school/task/regulation/list.vue"),
			},
			{
				name: "作业详情",
				path: "/task/regulation/registerDetail",
				component: () => import("@/views/school/task/register/registerDetail.vue"),
			},
		],
	},
	{
		name: "作业备案",
		path: "/task/record",
		component: () => import("@/views/school/task/record/index.vue"),
		redirect: "/task/record/list",
		children: [
			{
				name: "作业备案列表",
				path: "/task/record/list",
				component: () => import("@/views/school/task/record/list.vue"),
			},
			{
				name: "作业备案详情",
				path: "/task/record/detail",
				component: () => import("@/views/school/task/register/registerDetail.vue"),
			},
		],
	},
	{
		name: "作业反馈",
		path: "/task/feedback",
		component: () => import("@/views/school/task/feedback/index.vue"),
		redirect: "/task/feedback/list",
		children: [
			{
				name: "作业反馈",
				path: "/task/feedback/list",
				component: () => import("@/views/school/task/feedback/list.vue"),
			},
			{
				name: "查看作业反馈详情",
				path: "/task/feedback/feedbackDetail",
				component: () => import("@/views/school/task/feedback/feedbackDetail.vue"),
			},
		],
	},
	{
		name: "作业辅导",
		path: "/task/tutoring",
		component: () => import("@/views/school/task/tutoring/index.vue"),
	},
	{
		name: "作业分析",
		path: "/task/analysis",
		component: () => import("@/views/school/task/analysis/homepage/index.vue"),
	},
	// ==作业分析==
	{
		name: "作业设计质量",
		path: "/task/analysis/quality",
		component: () => import("@/views/school/task/analysis/quality/index.vue"),
		redirect: "/task/analysis/quality/list",
		children: [
			{
				name: "作业设计质量",
				path: "/task/analysis/quality/list",
				component: () => import("@/views/school/task/analysis/quality/list.vue"),
			},
			{
				name: "查看作业被驳回频次详情",
				path: "/task/analysis/quality/qualityDetail",
				component: () => import("@/views/school/task/analysis/quality/qualityDetail.vue"),
			},
		],
	},
	{
		name: "作业调控备案",
		path: "/task/analysis/regulationRecord",
		component: () => import("@/views/school/task/analysis/regulationRecord/index.vue"),
		redirect: "/task/analysis/regulationRecord/list",
		children: [
			{
				name: "作业调控备案",
				path: "/task/analysis/regulationRecord/list",
				component: () => import("@/views/school/task/analysis/regulationRecord/list.vue"),
			},
			{
				name: "作业备案详情",
				path: "/task/analysis/regulationRecord/recordDetail",
				component: () => import("@/views/school/task/analysis/regulationRecord/recordDetail.vue"),
			},
		],
	},
	{
		name: "作业评审情况",
		path: "/task/analysis/reviewSituation",
		component: () => import("@/views/school/task/analysis/reviewSituation/index.vue"),
		redirect: "/task/analysis/reviewSituation/list",
		children: [
			{
				name: "作业评审情况",
				path: "/task/analysis/reviewSituation/list",
				component: () => import("@/views/school/task/analysis/reviewSituation/list.vue"),
			},
			{
				name: "作业评审详情",
				path: "/task/analysis/reviewSituation/reviewDetail",
				component: () => import("@/views/school/task/analysis/reviewSituation/reviewDetail.vue"),
			},
		],
	},
	{
		name: "作业反馈异常",
		path: "/task/analysis/feedbackAbnormal",
		component: () => import("@/views/school/task/analysis/feedbackAbnormal/index.vue"),
		redirect: "/task/analysis/feedbackAbnormal/list",
		children: [
			{
				name: "作业评审情况",
				path: "/task/analysis/feedbackAbnormal/list",
				component: () => import("@/views/school/task/analysis/feedbackAbnormal/list.vue"),
			},
			{
				name: "作业评审详情",
				path: "/task/analysis/feedbackAbnormal/feedListDetail",
				component: () =>
					import("@/views/school/task/analysis/feedbackAbnormal/feedListDetail.vue"),
			},
		],
	},

	/**
	 *** 统计分析
	 **/
	// ==托管统计==
	{
		name: "教师考勤统计",
		path: "/statistical/HostingTeacherClass",
		component: () => import("@/views/school/statistical/hosting/teacherClass/index.vue"),
	},
	{
		name: "学生考勤统计",
		path: "/statistical/HostingStudentSign",
		component: () => import("@/views/school/statistical/hosting/studentSign/index.vue"),
	},
	{
		name: "学生托管统计",
		path: "/statistical/HostingStudentBution",
		component: () => import("@/views/school/statistical/hosting/studentBution/index.vue"),
	},
	// ==课程管理==
	{
		name: "课程考勤统计",
		path: "/statistical/AttendanceStatistics",
		component: () => import("@/views/school/statistical/course/attendanceStatistics/index.vue"),
	},
	{
		name: "课程开班统计",
		path: "/statistical/ShiftStatistics",
		component: () => import("@/views/school/statistical/course/shiftStatistics/index.vue"),
	},
	// ==机构管理==
	{
		name: "机构教师考勤统计",
		path: "/statistical/TeacherAttendance",
		component: () => import("@/views/school/statistical/enterprise/teacherAttendance/index.vue"),
	},
	{
		name: "机构课程统计",
		path: "/statistical/HostingStatistics",
		component: () => import("@/views/school/statistical/enterprise/hostingStatistics/index.vue"),
	},
	// ==评价统计==
	{
		name: "课程评价统计",
		path: "/statistical/evaluationCourse",
		component: () => import("@/views/school/statistical/evaluation/course/index.vue"),
	},
	{
		name: "教师评价统计",
		path: "/statistical/evaluationTeacher",
		component: () => import("@/views/school/statistical/evaluation/teacher/index.vue"),
	},

	/**
	 *** 服务管理
	 **/
	// ==费用管理==
	{
		name: "订单管理",
		path: "/service/Order",
		component: () => import("@/views/school/serviceManager/cost/order/index.vue"),
	},
	{
		name: "课酬管理",
		path: "/service/Money",
		component: () => import("@/views/school/serviceManager/cost/money/index.vue"),
	},
	{
		name: "结算管理",
		path: "/service/Settlement",
		component: () => import("@/views/school/serviceManager/cost/settlement/index.vue"),
	},
	// ==评价管理==
	{
		name: "课程评价管理",
		path: "/service/evaluationCourse",
		component: () => import("@/views/school/serviceManager/evaluation/course/index.vue"),
	},
	{
		name: "教师评价管理",
		path: "/service/evaluationTeacher",
		component: () => import("@/views/school/serviceManager/evaluation/teacher/index.vue"),
	},
	{
		name: "学生评价管理",
		path: "/service/evaluationStudent",
		component: () => import("@/views/school/serviceManager/evaluation/student/index.vue"),
	},
	// ==投诉管理==
	{
		name: "课程投诉管理",
		path: "/service/complaintsCourse",
		component: () => import("@/views/school/serviceManager/complaints/course/index.vue"),
	},
	{
		name: "教师投诉管理",
		path: "/service/complaintsTeacher",
		component: () => import("@/views/school/serviceManager/complaints/teacher/index.vue"),
	},
	{
		name: "收费投诉管理",
		path: "/service/evaluationCharge",
		component: () => import("@/views/school/serviceManager/complaints/charge/index.vue"),
	},
];

